<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="80px"
      :model="formLabelAlign"
    >
      <el-form-item label="名称">
        <el-input v-model="formLabelAlign.name"></el-input>
      </el-form-item>
      <el-form-item label="跳转地址">
        <el-input v-model="formLabelAlign.jump_page"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbirt"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { wxCpspromotionupdate } from '@/api/sourceminiprogram.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        jump_page: ''
      },
      id: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(type, item) {
      console.log(type, item)
      this.id = item.id
      this.formLabelAlign.name = item.name
      this.formLabelAlign.jump_page = item.jump_page
    },
    sumbirt() {
      if (this.formLabelAlign.name === '') {
        this.$message.error('请输入链接地址名称')
        return
      }
      if (this.formLabelAlign.jump_page === '') {
        this.$message.error('请输入跳转地址')
        return
      }
      wxCpspromotionupdate({ ...this.formLabelAlign, id: this.id }).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('updata')
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>